import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_AUDIENCE_LAYOUT, SET_BACKSTAGE_ROSTER, SET_JOIN_HIDDEN, SET_LOCAL_RECORDING_ALLOWED, SET_MAIN_ROOM_ROSTER, SET_MEDIA_BLOCK_ALL, SET_ROOM_SWITCH_TARGET, SET_START_BACKSTAGE } from './actionTypes';
const DEFAULT_STATE = {
    backstageRoster: [],
    mainRoomRoster: [],
    showOnlyPanelists: false,
    stageOnlyMode: false,
    startBackstage: false
};
ReducerRegistry.register('features/webinar', (state = DEFAULT_STATE, action) => {
    var _a;
    switch (action.type) {
        case SET_JOIN_HIDDEN:
            if (state.joinHiddenAudience === action.audience) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { joinHiddenAudience: action.audience });
        case SET_START_BACKSTAGE:
            if (state.startBackstage === action.enabled) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { startBackstage: action.enabled });
        case SET_AUDIENCE_LAYOUT:
            if (state.audienceLayoutRoom === action.roomName
                && state.showOnlyPanelists === action.showOnlyPanelists
                && state.stageOnlyMode === action.stageOnlyMode) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { audienceLayoutRoom: action.roomName, showOnlyPanelists: action.showOnlyPanelists, stageOnlyMode: action.stageOnlyMode });
        case SET_BACKSTAGE_ROSTER:
            return Object.assign(Object.assign({}, state), { backstageRoster: action.occupants });
        case SET_MAIN_ROOM_ROSTER:
            return Object.assign(Object.assign({}, state), { mainRoomRoster: action.occupants, mainRoomPolicy: (_a = action.policy) !== null && _a !== void 0 ? _a : state.mainRoomPolicy });
        case SET_MEDIA_BLOCK_ALL:
            if (state.mediaBlockAll === action.enabled) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { mediaBlockAll: action.enabled });
        case SET_ROOM_SWITCH_TARGET:
            if (state.roomSwitchTarget === action.target
                && state.roomSwitchFrom === action.fromRoom) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { roomSwitchTarget: action.target, roomSwitchFrom: action.fromRoom });
        case SET_LOCAL_RECORDING_ALLOWED:
            if (state.localRecordingAllowed === action.allowed) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { localRecordingAllowed: action.allowed });
        default:
            return state;
    }
});
